/* <lite-youtube> — click-to-play YouTube facade.
   On the first click it swaps the thumbnail for the real player iframe
   (autoplay), so YouTube's ~110 KB of player CSS/JS never load on page load. */

class LiteYoutube extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';
    this.addEventListener('click', () => this.#activate());
  }

  #activate() {
    const id = this.dataset.videoId;
    if (!id || this.classList.contains('yt-facade--on')) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'yt-facade__iframe';
    iframe.title = this.dataset.title || 'YouTube video player';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;

    this.replaceChildren(iframe);
    this.classList.add('yt-facade--on');
  }
}

if (!customElements.get('lite-youtube')) {
  customElements.define('lite-youtube', LiteYoutube);
}
